/* Pre-order batch schedule. The server render is correct at render time; this re-applies the
   same rules (see snippets/pw-preorder.liquid) against today's date in the store's cutoff
   timezone, because cached pages can outlive a cutoff. Also keeps the ship-date line item
   property on the product form in sync with the current batch. */

(function () {
  if (customElements.get('pw-preorder')) return;

  var DAY_MS = 86400000;

  function todayIn(timeZone) {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (e) {
      var d = new Date();
      return [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-');
    }
  }

  function toUTC(ymd) {
    var p = ymd.split('-');
    return Date.UTC(+p[0], +p[1] - 1, +p[2]);
  }

  function fill(template, values) {
    return String(template || '').replace(/\[(date|days|cutoff|percent)\]/g, function (m, key) {
      return values[key] != null ? values[key] : m;
    });
  }

  customElements.define(
    'pw-preorder',
    class PwPreorder extends HTMLElement {
      connectedCallback() {
        try {
          this.text = JSON.parse(this.querySelector('[data-pw-preorder-text]').textContent);
        } catch (e) {
          this.text = {};
        }
        this.update();

        this._onVisible = function () {
          if (document.visibilityState === 'visible') this.update();
        }.bind(this);
        document.addEventListener('visibilitychange', this._onVisible);

        /* capture phase runs before the product form's own submit handler builds its FormData */
        this._onSubmit = function (e) {
          if (e.target && e.target.id === this.dataset.formId) this.update();
        }.bind(this);
        document.addEventListener('submit', this._onSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this._onVisible);
        document.removeEventListener('submit', this._onSubmit, true);
      }

      update() {
        var t = this.text;
        var today = todayIn(this.dataset.timezone);
        var todayMs = toUTC(today);
        var rows = Array.prototype.slice.call(this.querySelectorAll('.pw-preorder__row'));
        var maxUpcoming = parseInt(this.dataset.maxUpcoming, 10) || 0;
        var showPast = this.hasAttribute('data-show-past');

        var states = rows.map(function (row) {
          var pct = parseInt(row.dataset.pct, 10) || 0;
          var closed = row.hasAttribute('data-sold-out') || pct >= 100 || today > row.dataset.cutoff;
          return closed ? 'closed' : 'open';
        });

        var current = states.indexOf('open');
        var lastPast = -1;
        for (var i = 0; i < (current === -1 ? states.length : current); i++) {
          if (states[i] === 'closed') lastPast = i;
        }

        rows.forEach(function (row, i) {
          var pct = parseInt(row.dataset.pct, 10) || 0;
          var state = states[i] === 'closed' ? 'closed' : i === current ? 'current' : 'upcoming';
          var visible =
            i === current ||
            (current !== -1 && i > current && i - current <= maxUpcoming) ||
            (i === lastPast && showPast);

          row.className = 'pw-preorder__row pw-preorder__row--' + state;
          row.hidden = !visible;
          row.querySelector('.pw-preorder__fill').style.setProperty('--pw-fill', (state === 'current' ? pct : 0) + '%');

          var label =
            state === 'closed'
              ? t.labelClosed
              : state === 'current'
              ? pct > 0
                ? fill(t.labelReserved, { percent: pct })
                : t.labelOpen
              : t.labelUpcoming;
          row.querySelector('[data-row-label]').textContent = label || '';
        });

        var heading, sub, shipLabel = null;
        if (current !== -1) {
          var row = rows[current];
          var days = Math.round((toUTC(row.dataset.cutoff) - todayMs) / DAY_MS);
          var values = { date: row.dataset.label, days: days, cutoff: row.dataset.cutoffLabel };
          heading = fill(t.heading, values);
          sub = fill(days === 0 ? t.subToday : days === 1 ? t.subTomorrow : t.subDays, values);
          shipLabel = row.dataset.label;
        } else {
          heading = t.closedHeading;
          sub = t.closedSub;
        }

        this.querySelector('[data-heading]').textContent = heading || '';
        var subEl = this.querySelector('[data-sub]');
        subEl.textContent = sub || '';
        subEl.hidden = !sub;
        this.hidden = current === -1 && this.hasAttribute('data-hide-when-closed');

        this.syncProperty(shipLabel);
      }

      syncProperty(shipLabel) {
        var name = this.dataset.property;
        var form = document.getElementById(this.dataset.formId);
        if (!name || !form) return;

        var fieldName = 'properties[' + name + ']';
        var input = form.querySelector('input[data-pw-preorder-property]');
        if (!shipLabel) {
          if (input) input.remove();
          return;
        }
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.setAttribute('data-pw-preorder-property', '');
          form.appendChild(input);
        }
        input.name = fieldName;
        input.value = shipLabel;
      }
    }
  );
})();
